<script>
export default {
  name: 'Pagination',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      default: 5,
    }
  },
  computed: {
    hasNext() {
      const { page, pageCount } = this.pagination;
      return page < pageCount;
    },
    hasPrevious() {
      return this.pagination.page > 1;
    },
    pages() {
      const { page, pageCount } = this.pagination;
      const { total } = this;
      const perSide = Math.ceil((total - 1) / 2);

      if (!pageCount || !total) {
        return pagesGenerator(1, 1);
      }

      const pagesGenerator = (start, end) => {
        const pages = [];
        for (let i = start; i <= end; i++) {
          pages.push({
            page: i,
            isCurrent: page === i,
          })
        }
        return pages;
      };

      const pages = {
        start: 1,
        end: 1,
      };

      if (pageCount < total) {
        pages.start = page;
        pages.end = pageCount;
      }
      else {
        pages.start = page - perSide;
        pages.end = page + perSide;
      }

      if (pages.start < 1) {
        pages.start = 1;
        pages.end = (pageCount > total) ? total : pageCount;
      }

      if (pages.end > pageCount) {
        const diff = pages.end - pageCount;
        pages.start = pages.start - diff;
        pages.end = pageCount;
      }

      return pagesGenerator(pages.start, pages.end);
    },
    currentRecords() {
      const { page, pageSize, totalHits, pageCount = 0 } = this.pagination;
      const currentRecords = {
        first: (page < 2) ? 1 : ((page - 1) * pageSize) + 1,
        last: page * pageSize,
      };

      if (pageCount < 1) {
        currentRecords.first = 0;
      }

      if (totalHits < currentRecords.last) {
        currentRecords.last = totalHits;
      }

      return currentRecords;
    },
  },
  methods: {
    onClick(page) {
      this.$emit('input', page);
    },
  }
};
</script>
<style lang="scss" scoped>
  .page-link:focus {
    box-shadow: none;
  }
</style>
<template>
  <div class="d-flex justify-content-between align-items-center">
    <span>
      Displaying {{ currentRecords.first }} to {{ currentRecords.last || 0 }} out of {{ pagination.totalHits || 0 }} records
    </span>
    <nav>
      <ul class="pagination justify-content-end" v-if="pagination.pageCount && pagination.pageCount > 0">
        <li class="page-item" :class="{disabled: !hasPrevious}">
          <a class="page-link" href="#" tabindex="-1" @click.prevent="onClick(pagination.page - 1)">Previous</a>
        </li>
        <li class="page-item" :class="{disabled: page.isCurrent}" v-for="(page, index) in pages" :key="index">
          <a class="page-link" v-if="page.isCurrent" href="#">{{ page.page }}</a>
          <a class="page-link" v-else href="#" @click.prevent="onClick(page.page)">{{ page.page }}</a>
        </li>
        <li class="page-item" :class="{disabled: !hasNext}">
          <a class="page-link" href="#" @click.prevent="onClick(pagination.page + 1)">Next</a>
        </li>
      </ul>
      <ul class="pagination justify-content-end" v-else>
        <li class="page-item" :class="{disabled: !hasPrevious}">
          <a class="page-link" href="#" tabindex="-1" @click.prevent="onClick(pagination.page - 1)">Previous</a>
        </li>
        <li class="page-item" :class="{disabled: !hasNext}">
          <a class="page-link" href="#" @click.prevent="onClick(pagination.page + 1)">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</template>
